import React, { useEffect, useState } from "react";
import { getToken } from "../utils/authUtils";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Modal,
  Spinner,
  Form,
  Alert,
  Button,
} from "react-bootstrap";
import moment from "moment";
import CatalogHeader from "./CatalogHeader";
import { BottomSheet } from "react-spring-bottom-sheet";
import { setToast } from "../App/Components/Toast";
import CatalogListModal from "../App/Components/CatalogListModal";
import Cookies from "js-cookie";
import TileView from "../App/Components/Showcase/3DTileView";
import RoomSelectionModal from "./RoomSelectionModal";
import { useMediaQuery } from "react-responsive";

interface ProductData {
  id: number;
  image_url: string;
  product_name_slug: string;
  height: number;
  width: number;
  is_for_floor: number;
  is_for_wall: number;
  created_at: string;
  updated_at: string;
}

interface Catalog {
  id: number;
  title: string;
  catalog_url: string;
}

const SeeCatalogDetails = () => {
  const URLAiVisualizer = Cookies.get("URLAiVisualizer");
  const isMobile = useMediaQuery({ maxWidth: 430 });
  const { id } = useParams();
  const navigate = useNavigate();
  const [specificProductData, setSpecificProductData] =
    useState<ProductData | null>(null);
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [catalogData, setCatalogData] = useState<Catalog[]>([]);
  const [showCatalogListModal, setShowCatalogListModal] = useState(false);
  // eslint-disable-next-line
  const [isSaved, setIsSaved] = useState(false);
  const [showCreateCatalogModal, setShowCreateCatalogModal] = useState(false);
  const [catalogTitle, setCatalogTitle] = useState("");
  const [titleError, setTitleError] = useState("");
  const [creatingCatalog, setCreatingCatalog] = useState(false);
  // eslint-disable-next-line
  const [catalogId, setCatalogId] = useState(null);
  const [showCatalogModal, setShowCatalogModal] = useState(false);
  const [is3dRoomViewHovered, setIs3dRoomViewHovered] = useState(false);
  const [isTilesInfoHovered, setIsTilesInfoHovered] = useState(false);
  const [isSaveCatalogHovered, setIsSaveCatalogHovered] = useState(false);
  const [isLoading3dView, setIsLoading3dView] = useState(false);
  const [showRoomModal, setShowRoomModal] = useState(false);

  // const handleaivisualizer = () => {
  //   const queryString = URLAiVisualizer?.toString();
  //   const finalQuery = queryString
  //     ? `${queryString}&ai_img_id=${id}`
  //     : `ai_img_id=${id}`;
  //   navigate(`/ai-visualizer?${finalQuery}`);
  // };

  useEffect(() => {
    const token = getToken();
    if (token) {
      const getSpecificProduct = async (token: string) => {
        try {
          const apiUrl = `${process.env.REACT_APP_API_URL}api/public_products/${id}`;
          const response = await axios.get(apiUrl, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setSpecificProductData(response.data.data);
        } catch (error) {
          console.error("Error fetching data from the API:", error);
        }
      };
      getSpecificProduct(token);
    } else {
      console.error("No token available");
    }
  }, [id]);

  const fetchCatalog = async () => {
    const userToken = getToken();
    try {
      if (!userToken) {
        return;
      }
      const apiUrlCatalog = `${process.env.REACT_APP_API_URL}api/visitor/catalogs`;
      const response = await axios.get(apiUrlCatalog, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });
      setCatalogData(response.data.data);
    } catch (error) {
      console.error("Error fetching Catalogs:", error);
    }
  };
  useEffect(() => {
    fetchCatalog();
  }, []);

  const handleCardClick = async (catalogId: number) => {
    const userToken = getToken();

    if (!userToken || !specificProductData?.id) {
      setToast("error", "Missing token or product data.");
      return;
    }

    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}api/catalog/${catalogId}/catalogImage`;

      const response = await axios.post(
        apiUrl,
        { ai_image_id: specificProductData.id },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      setCatalogId(response.data.data.id);
      setToast("success", "Catalog successfully saved.");
      setIsSaved(true);
      toggleCatalogListModal();
    } catch (error) {
      console.error("Error saving catalog:", error);
      setToast("error", "Something went wrong. Please try again later.");
    }
  };

  useEffect(() => {
    setIsSaved(false);
  }, [specificProductData?.id]);

  const toggleCatalogListModal = () => {
    setShowCatalogListModal(!showCatalogListModal);
  };
  const closeCatalogListModal = () => {
    setShowCatalogListModal(false);
  };

  const toggleCreateCatalogModal = () => {
    setShowCreateCatalogModal(!showCreateCatalogModal);
    setShowCatalogListModal(!showCatalogListModal);
  };
  const handleCatalogTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCatalogTitle(e.target.value);
    setTitleError("");
  };
  const handleCreateCatalogSubmit = async () => {
    if (!catalogTitle.trim()) {
      setTitleError("Please enter a title for the catalog");
    } else {
      setCreatingCatalog(true);
      await addToCatalog(catalogTitle);
      setCreatingCatalog(false);
    }
  };
  const addToCatalog = async (title: string) => {
    const userToken = getToken();
    try {
      if (!userToken) {
        return;
      }
      const apiUrl = (process.env.REACT_APP_API_URL as string) + "api/catalogs";
      const response = await axios.post(
        apiUrl,
        {
          title: title,
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      const catalogId = response.data.data.id;
      setCatalogId(catalogId);
      fetchCatalog();
      setToast("success", "New catalog Created Successfully.");
      toggleCreateCatalogModal();
    } catch (error) {
      console.error("Error creating catalog:", error);
      setToast("error", "Something went wrong. Please try again later.");
    }
  };

  const toggleCatalogModal = () => {
    setShowCatalogModal(!showCatalogModal);
  };

  // const handle3dRoomViewClick = () => {
  //     setIsLoading3dView(true);
  //     navigate(`/show-case/catalog-screen/see-catalog/${id}/see-catalog-details/room-view`);
  // }
  // const handle3dRoomViewClick = () => {
  //   setIsLoading3dView(true); // Set loading state immediately

  //   // Log for debugging
  //   console.log("Loading state:", isLoading3dView);

  //   // Simulate loading delay before navigating to the new page
  //   setTimeout(() => {
  //     navigate(
  //       `/show-case/catalog-screen/see-catalog/${id}/see-catalog-details/room-view?imgURL=${specificProductData?.image_url}`
  //     );
  //   }, 300); // 300ms delay to simulate loading
  // };
  const handle3dRoomViewClick = (roomKey: string) => {
    setIsLoading3dView(true);
    setTimeout(() => {
      navigate(
        `/show-case/catalog-screen/see-catalog/${id}/see-catalog-details/room-view?room=${roomKey}&imgURL=${specificProductData?.image_url}`
      );
    }, 300);
  };

  const dataList = [
    {
      label: "Product type",
      value: specificProductData?.is_for_wall
        ? "Walls"
        : specificProductData?.is_for_floor
        ? "Floor"
        : "N/A",
    },
    { label: "Title", value: specificProductData?.product_name_slug || "-" },
    { label: "Width", value: specificProductData?.width || "-" },
    { label: "Height", value: specificProductData?.height || "-" },
    {
      label: "Created at",
      value: specificProductData?.created_at
        ? moment(specificProductData?.created_at).format("DD-MMM-YYYY")
        : "-",
    },
    {
      label: "Updated at",
      value: specificProductData?.updated_at
        ? moment(specificProductData?.updated_at).format("DD-MMM-YYYY")
        : "-",
    },
  ];

  const lastIndex = dataList.length - 1;

  return (
    <div className="custom-container-see-catalog mb-5">
      <CatalogHeader showSearch={false} />
      <Container className="custom-container-details mb-5">
        <Row className="justify-content-center align-items-start">
          <Col
            xs={12}
            md={5}
            className="d-flex justify-content-center mb-3 mb-md-0"
          >
            <div className="service-box-details">
              <img
                src={specificProductData?.image_url}
                alt={specificProductData?.product_name_slug}
              />
            </div>
          </Col>
          <Col xs={11} md={7} className="">
            <div className="w-100 details-box">
              <div className="p-3 px-5 d-flex justify-content-start align-items-center details-header">
                <h6
                  className="m-0 text-break"
                  style={{
                    color: "#FBCB7D",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  {specificProductData?.product_name_slug
                    ? specificProductData.product_name_slug
                        .split("_")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ")
                    : "N/A"}
                </h6>
              </div>
              <div className="px-5 bg-transparent">
                {dataList.map((item, index) => (
                  <Row
                    key={index}
                    className="py-2 align-items-center"
                    style={{
                      borderBottom:
                        index === lastIndex ? "none" : "1px dashed #8B8C8D",
                      overflow: "hidden",
                      height: "50px",
                    }}
                  >
                    <Col xs={6} className="font-14-fw-500 details-title">
                      {item.label}
                    </Col>
                    <Col xs={6} className="details-titl-value text-break">
                      {item.value}
                    </Col>
                  </Row>
                ))}
              </div>
            </div>
            {!isMobile && (
              <div className="py-4">
                <div className="d-flex justify-content-between flex-wrap my-3">
                  <button
                    className="custom-uniform-blue-btn text-start"
                    onClick={() => setShowRoomModal(true)}
                    onMouseEnter={() => setIs3dRoomViewHovered(true)}
                    onMouseLeave={() => setIs3dRoomViewHovered(false)}
                  >
                    {isLoading3dView ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        variant="dark"
                        className="me-1"
                      />
                    ) : (
                      <img
                        src={
                          is3dRoomViewHovered
                            ? "/icon/3d-view-icon-white.svg"
                            : "/icon/3d-view-icon.svg"
                        }
                        alt=""
                        className="me-1"
                        height="28px"
                        width="28px"
                      />
                    )}
                    {isLoading3dView ? "Loading..." : "360° View"}
                  </button>
                  {/* <button
                  className="custom-uniform-blue-btn text-start"
                  onClick={handleaivisualizer}
                  onMouseEnter={() => setIsAiVisualizerHovered(true)}
                  onMouseLeave={() => setIsAiVisualizerHovered(false)}
                >
                  <img
                    src={
                      isaiVisualizerHovered
                        ? "/icon/ai-visualizer-icon-white.svg"
                        : "/icon/ai-visualizer-icon.svg"
                    }
                    alt=""
                    className="me-1"
                    height={"28px"}
                    width={"28px"}
                  />
                  AI-Visualizer
                </button> */}
                  <button
                    className="custom-uniform-blue-btn"
                    onClick={handleOpenModal}
                    onMouseEnter={() => setIsTilesInfoHovered(true)}
                    onMouseLeave={() => setIsTilesInfoHovered(false)}
                  >
                    <img
                      src={
                        isTilesInfoHovered
                          ? "/icon/info-icon-white.svg"
                          : "/icon/info-icon.svg"
                      }
                      alt=""
                      className="me-1"
                      height={"28px"}
                      width={"28px"}
                    />
                    3D View
                  </button>
                  <button
                    className="custom-uniform-blue-btn"
                    onClick={toggleCatalogListModal}
                    onMouseEnter={() => setIsSaveCatalogHovered(true)}
                    onMouseLeave={() => setIsSaveCatalogHovered(false)}
                  >
                    <img
                      src={
                        isSaveCatalogHovered
                          ? "/icon/save-icon-white.svg"
                          : "/icon/save-icon.svg"
                      }
                      alt=""
                      className="me-1"
                      height={"28px"}
                      width={"28px"}
                    />
                    Save
                  </button>
                </div>
              </div>
            )}
          </Col>
        </Row>
        <Modal
          centered
          show={showCreateCatalogModal}
          onHide={toggleCreateCatalogModal}
          dialogClassName="createcatalogmodel"
        >
          <Modal.Body className="tile-view-3d-background">
            <Modal.Title className="text-center" style={{ color: "#ffffff" }}>
              Create New Catalog
            </Modal.Title>
            <Form.Group controlId="catalogTitle">
              <Form.Label className="fw-bold" style={{ color: "#ffffff" }}>
                Catalog Title
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter catalog title"
                className="custom-search-input"
                onChange={handleCatalogTitleChange}
              />
              {titleError && (
                <Alert className="mt-1" variant="danger">
                  {titleError}
                </Alert>
              )}
            </Form.Group>
            <div className="border-0 mt-4 d-flex justify-content-around">
              <button
                className="btn btn-sm uniform-delete-btn"
                style={{ width: "45%" }}
                onClick={toggleCreateCatalogModal}
              >
                Cancel
              </button>
              <button
                className="btn btn-sm uniform-success-btn"
                style={{
                  width: "45%",
                  background: "#00B196",
                  color: "#ffffff",
                }}
                onClick={handleCreateCatalogSubmit}
                disabled={creatingCatalog}
              >
                {creatingCatalog ? (
                  <span>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    &nbsp; Creating...
                  </span>
                ) : (
                  "Create Catalog"
                )}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <BottomSheet
          className={`ProductDetailsBottom`}
          snapPoints={({ minHeight, maxHeight }) => [
            minHeight,
            maxHeight - 120,
          ]}
          open={showCatalogListModal}
          onDismiss={closeCatalogListModal}
        >
          <div className="p-5">
            <div className="text-center">
              <h5 style={{ color: "white" }}>Select Catalog</h5>
            </div>
            <div
              className="card mt-3 select-Catalog border-0 w-100"
              style={{ margin: "0 auto", background: "transparent" }}
            >
              {catalogData.length === 0 ? (
                <p className="text-center" style={{ color: "white" }}>
                  No Content Available.
                </p>
              ) : (
                <div>
                  {catalogData.map((catalog) => (
                    <div
                      key={catalog.id}
                      className="card mb-4"
                      style={{
                        paddingTop: "11px",
                        cursor: "pointer",
                        background: "transparent",
                        border: "1px solid #DAA520",
                      }}
                      onClick={() => handleCardClick(catalog.id)}
                    >
                      <div
                        className="card-body"
                        style={{ background: "transparent", color: "white" }}
                      >
                        <div>
                          <p className="ms-1" style={{ marginRight: "15px" }}>
                            <strong> {catalog.title} </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
                className="border-0 mb-2"
              >
                <button
                  className="create-catalog-btn p-3 border-0 save-to-Catalog w-100"
                  onClick={toggleCreateCatalogModal}
                >
                  Create Catalog
                </button>
              </div>
            </div>
          </div>
        </BottomSheet>
        <CatalogListModal
          showCatalogModal={showCatalogModal}
          closeCatalogModal={toggleCatalogModal}
        />
        <TileView
          show={showModal}
          handleClose={handleCloseModal}
          specificProductData={specificProductData}
        />
        <RoomSelectionModal
          show={showRoomModal}
          onClose={() => setShowRoomModal(false)}
          onRoomSelect={handle3dRoomViewClick}
        />
      </Container>
      {isMobile && (
        <div
          className="fixed-bottom bg-dark pt-0 pb-2 border-0"
          style={{ zIndex: 1030 }}
        >
          <div className="d-flex justify-content-between py-4 px-3 gap-2">
            <Button
              className="bottom-panel-for-slider flex-fill"
              onClick={() => setShowRoomModal(true)}
            >
              {isLoading3dView ? (
                <Spinner
                  animation="border"
                  size="sm"
                  variant="dark"
                  className="me-1"
                />
              ) : (
                <img
                  src={"/icon/3d-view-icon-white.svg"}
                  alt=""
                  className="me-1"
                  height="20"
                  width="20"
                />
              )}
              {isLoading3dView ? "Loading..." : "360°"}
            </Button>

            <Button
              className="bottom-panel-for-slider flex-fill"
              onClick={handleOpenModal}
            >
              <img
                src={"/icon/info-icon-white.svg"}
                alt=""
                className="me-1"
                height="20"
                width="20"
              />
              3D View
            </Button>

            <Button
              className="bottom-panel-for-slider flex-fill"
              onClick={toggleCatalogListModal}
            >
              <img
                src={"/icon/save-icon-white.svg"}
                alt=""
                className="me-1"
                height="20"
                width="20"
              />
              Save
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SeeCatalogDetails;
